import React from "react";
import Qualifications from "../../views/Qualifications";

const QualificationPage = () => {
  return <Qualifications />;
};

export default QualificationPage;
